import type { Lead } from "@/types/lead";
import { formatShortTime } from "@/lib/format/time";
import {
  leadCreatedAtMs,
  resolveLeadLocationLabel,
  resolveLeadOwnerLabel,
} from "@/lib/lead/leadsManagerFilters";

export function LeadProvenanceMeta(props: {
  lead: Lead;
  ownerLabelByUserId: Map<string, string>;
  locationNameById: Map<string, string>;
  showOwner?: boolean;
  showLocation?: boolean;
  compact?: boolean;
}) {
  const {
    lead,
    ownerLabelByUserId,
    locationNameById,
    showOwner = true,
    showLocation = true,
    compact = false,
  } = props;

  const owner = showOwner ? resolveLeadOwnerLabel(lead, ownerLabelByUserId) : null;
  const location = showLocation ? resolveLeadLocationLabel(lead, locationNameById) : null;
  const created = formatShortTime(leadCreatedAtMs(lead));

  if (!owner && !location) return null;

  const className = compact
    ? "text-[11px] text-gray-500 dark:text-gray-400"
    : "text-xs text-slate-600 dark:text-slate-300";

  return (
    <p className={className}>
      {owner ? (
        <>
          <span className="font-medium text-slate-700 dark:text-slate-200">Created by</span> {owner}
        </>
      ) : null}
      {owner && location ? " · " : null}
      {location ? (
        <>
          <span className="font-medium text-slate-700 dark:text-slate-200">Location</span> {location}
        </>
      ) : null}
      {(owner || location) && created ? " · " : null}
      {created ? (
        <>
          <span className="font-medium text-slate-700 dark:text-slate-200">Captured</span> {created}
        </>
      ) : null}
    </p>
  );
}
